import React, {useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faForward, faBackward } from '@fortawesome/free-solid-svg-icons';
import { setBooleanState, setVolume, setShowSecondsSteppedLeft, setShowSecondsSteppedRight } from '../../../features/videoPlayer/videoPlayer.slice'

const KeydownPlayerToasters = ({videoRef, togglePlayPause}) => {
    
    const showStepToastLeft = useSelector((state) => state.videoPlayer.showStepToastLeft);
    const showStepToastRight = useSelector((state) => state.videoPlayer.showStepToastRight);
    const showSecondsSteppedLeft = useSelector((state) => state.videoPlayer.showSecondsSteppedLeft);
    const showSecondsSteppedRight = useSelector((state) => state.videoPlayer.showSecondsSteppedRight);
    const volumeToaster = useSelector((state) => state.videoPlayer.volumeToaster);
    const volume = useSelector((state) => state.videoPlayer.volume);

    let toastVolumeTimeout;
    let toastTimeoutLeft;
    let toastTimeoutRight;
    
    const dispatch = useDispatch();

    useEffect(() => {
        const handleGlobalKeyDown = (event) => {
            handleKeyDown(event); // Call your existing keydown handler
        };

        document.addEventListener('keydown', handleGlobalKeyDown);

        return () => {
            document.removeEventListener('keydown', handleGlobalKeyDown); // Cleanup
        };
    }, []);

    const handleKeyDown = (event) => {

        // Clear existing timeout
        clearTimeout(toastVolumeTimeout);

        toastVolumeTimeout = setTimeout(() => dispatch(setBooleanState({ key: 'volumeToaster', value: false })), 3000);

        switch (event.code) {
        case 'Space':
            event.preventDefault();
            event.stopPropagation();
            togglePlayPause(videoRef);
            break;
        case 'ArrowLeft':
            event.preventDefault();
            handleStepToastLeft(videoRef);
            break;
        case 'ArrowRight':
            event.preventDefault();
            handleStepToastRight(videoRef);
            break;
        case 'ArrowUp':
            event.preventDefault();
            handleVolumeChange('up');
            // toastVolumeTimeout = setTimeout(() => setVolumeToaster(false), 3000);
            break;
        case 'ArrowDown':
            event.preventDefault();
            handleVolumeChange('down');
            // toastVolumeTimeout = setTimeout(() => setVolumeToaster(false), 3000);
            break;
        default:
            break;
        }
    };

    const handleStepToastLeft = (videoRef) => {
    
      const video = videoRef.current;
      // const currentTime = video.currentTime;
      
      // Clear existing timeout
      clearTimeout(toastTimeoutLeft);
    
      if (video.currentTime === 0) {
        dispatch(setBooleanState({ key: 'showStepToastLeft', value: false }));
        // setBooleanState({ key: 'showSecondsSteppedLeft', value: 0 });
        dispatch(setShowSecondsSteppedLeft(0));
        return;
      }
    
      video.currentTime = Math.max(0, video.currentTime - 5);
    
      // Hide previous toast if visible
      dispatch(setBooleanState({ key: 'showStepToastRight', value: false }));
      dispatch(setShowSecondsSteppedRight(0));
    
      // Show seconds stepped left
      dispatch(setShowSecondsSteppedLeft(5));
    
      // Show toast for stepping left
      dispatch(setBooleanState({ key: 'showStepToastLeft', value: true }));
    
      // Set new timeout
      toastTimeoutLeft = setTimeout(() => {dispatch(setBooleanState({ key: 'showStepToastLeft', value: false })); dispatch(setShowSecondsSteppedLeft(0)); }, 3000);
    };
    
    const handleStepToastRight = (videoRef) => {
    
      const video = videoRef.current;
      // const currentTime = video.currentTime;
      // const totalDuration = video.duration;
    
      
      // Clear existing timeout
      clearTimeout(toastTimeoutRight);
      
      // Hide previous toast if visible
      dispatch(setBooleanState({ key: 'showStepToastLeft', value: false }));
      dispatch(setShowSecondsSteppedLeft(0));
    
      video.currentTime = Math.min(video.duration, video.currentTime + 5);
      
      if (video.currentTime === video.duration) {
        dispatch(setBooleanState({ key: 'showStepToastRight', value: false }));
        dispatch(setShowSecondsSteppedRight(0));
        return;
      }
    
      // Show seconds stepped right
      dispatch(setShowSecondsSteppedRight(5));
    
      // Show toast for stepping right
      dispatch(setBooleanState({ key: 'showStepToastRight', value: true }));
    
      // Set new timeout
      toastTimeoutRight = setTimeout(() => {dispatch(setBooleanState({ key: 'showStepToastRight', value: false })); dispatch(setShowSecondsSteppedRight(0)); }, 3000);
    };

    const handleVolumeChange = (direction) => {

        // Clear existing timeout
        clearTimeout(toastVolumeTimeout);

        dispatch(setVolume(direction));
        dispatch(setBooleanState({ key: 'volumeToaster', value: true }));

        toastVolumeTimeout = setTimeout(() => dispatch(setBooleanState({ key: 'volumeToaster', value: false })), 3000);
    };

        // const updateVolume = () => {
        //   const video = videoRef.current;
        //   video.volume = volume / 100;
        // };
      
        // useEffect(() => {
        //   updateVolume();
        // }, [volume]);

    return (
        <div>
            <div
            style={{
                position: 'absolute',
                top: '50%',
                left: '70px',
                transform: 'translate(-50%, -50%)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                visibility: showStepToastLeft ? 'visible' : 'hidden',
                zIndex: 2,
            }}
            >
            <button
                style={{
                color: '#fff',
                background: 'none',
                border: 'none',
                fontSize: '2.5rem',
                marginRight: '20px',
                opacity: showStepToastLeft ? 1 : 0,
                transition: 'opacity 0.5s ease',
                }}
            >
                <FontAwesomeIcon icon={faBackward} />
            </button>
            <p style={{fontSize: '14px'}}>{showSecondsSteppedLeft} Seconds</p>
            </div>
    
            <div
            style={{
                position: 'absolute',
                top: '50%',
                right: '70px',
                transform: 'translate(50%, -50%)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                // backgroundColor: 'rgba(0, 0, 0, 0.5)',
                // borderRadius: '8px',
                // padding: '10px',
                // width: '80px',
                // height: '80px',
                visibility: showStepToastRight ? 'visible' : 'hidden',
                zIndex: 2,
            }}
            >
            <button
                style={{
                color: '#fff',
                background: 'none',
                border: 'none',
                fontSize: '2.5rem',
                marginLeft: '20px',
                opacity: showStepToastRight ? 1 : 0,
                transition: 'opacity 0.5s ease',
                }}
            >
                <FontAwesomeIcon icon={faForward} />
            </button>
            <p style={{fontSize: '14px'}}>{showSecondsSteppedRight} Seconds</p>
            </div>
    
            <div
            style={{
                position: 'absolute',
                top: '50px',
                right: '50%',
                transform: 'translate(50%, -50%)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                // visibility: showStepToastRight ? 'visible' : 'hidden',
                zIndex: 2,
            }}
            >
            <p
                className='d-none d-md-block'
                style={{
                fontSize: '21px', 
                color: 'white', 
                backgroundColor: 'rgba(0, 0, 0, 0.5)', 
                padding: '10px', 
                borderRadius: '5px', 
                width: '80px', 
                textAlign: 'center',
                visibility: volumeToaster ? 'visible' : 'hidden',
                // visibility: 'visible'
                }}
            >
                {volume}%
            </p>
            </div>
        </div>
    )
}

export default KeydownPlayerToasters